import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { IKIBusinessPriority } from 'legacy/lut/features/partner360/jbpSettings/models/kiBusinessPriority'

import { isMdfStrategicInitiative } from './keyInitiativeMdfFunding'

export const isKeyInitiativeBusinessPrioritiesVisible = (
  availablePriorities: readonly IKIBusinessPriority[],
  initialPriorities?: readonly string[] | null
): boolean => availablePriorities.length > 0 || Boolean(initialPriorities?.length)

/** Shared by the step editor and previous-year copy validation. */
export const isKeyInitiativeBusinessPrioritiesRequired = (
  keyObjective: string | null | undefined,
  keyObjectives: readonly IKeyObjective[],
  isVisible: boolean
): boolean => isVisible && isMdfStrategicInitiative(keyObjective, keyObjectives)

export const hasKeyInitiativeBusinessPriorities = (
  priorities?: readonly string[] | null
): boolean => Boolean(priorities?.some((priority) => priority.trim()))
